import type { InstanceStatus } from '../types';

const LABEL: Record<InstanceStatus, string> = {
  pending: 'ממתין',
  in_progress: 'בתהליך',
  completed: 'הושלם',
};
const VARIANT: Record<InstanceStatus, string> = {
  pending: 'badge',
  in_progress: 'badge badge-warning',
  completed: 'badge badge-success',
};

export function StatusBadge({ status }: { status: InstanceStatus }) {
  return (
    <span className={VARIANT[status]} data-testid={`status-${status}`}>
      <span className="badge-dot" aria-hidden="true" />
      {LABEL[status]}
    </span>
  );
}
